// @ts-nocheck
import * as _0 from "./amino";
export const amino = {
  ..._0
};